import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HomeMobileNavbar from "../components/HomeMobileNavbar";

const faqsData = [
  {
    id: "01",
    title: "Shipping and Delivery",
    items: [
      {
        q: "All clothing products are shipped within 5-10 working days (Monday to Friday).",
      },
      {
        q: "Maximum delivery time is 7 days.",
      },
      {
        q: "For tracking your order, you'll receive a WhatsApp message with tracking details as soon as your order ships from our studio.",
      },
      {
        q: "Shipping charges are subject to your delivery pincode.",
      },
    ],
  },
  {
    id: "02",
    title: "Missing Package",
    items: [
      {
        q: "If you don't receive your package within 20 days after shipping, contact us at our support email people@nufab.studio or Whatsapp us at +91 92445 91941.",
      },
      {
        q: "⁠We'll resend a new package or provide a full refund, and we are responsible for our products until they are delivered to you.",
      },
      {
        q: "If the parcel goes missing during delivery, then this will be a legal matter between our delivery partner and us.",
      },
    ],
  },
  {
    id: "03",
    title: "Contact Us",
    items: [
      {
        q: "Support Email: people@nufab.studio",
      },
      {
        q: "Phone: +91 9244501941",
      },
      {
        q: "Support Hours: Monday to Saturday, 11:00 AM – 7:00 PM IST",
      },
      {
        q: "The company holds the authority to make the final decision.",
      },
    ],
  },
];

const ExchangePage = () => {
  const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
 React.useEffect(() => {
     const handleResize = () => setWindowWidth(window.innerWidth);
     window.addEventListener('resize', handleResize);
     return () => window.removeEventListener('resize', handleResize);
   }, []);
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}
    <div className="w-full max-w-full mx-auto px-4 md:px-6 py-10 md:py-20 font-[bdogrotesk] text-black">
      <p className="text-black text-lg font-medium mb-6 md:mb-0">Delivery Policy</p>
      {faqsData.map((section, sectionIdx) => (
        <div
          key={section.id}
          // RESPONSIVE: Stack vertically on mobile, horizontal on desktop
          className="flex flex-col lg:flex-row gap-6 lg:gap-10 border-b border-black pt-10 pb-4 md:pb-10 lg:pb-0"
        >
          {/* Left column (ID) */}
          <div className="text-base font-medium text-black tracking-wide w-full lg:w-20 flex-shrink-0">
            {section.id}
          </div>

          {/* Right column Wrapper */}
          <div className="flex-1 flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(260px,1fr)_minmax(560px,1.2fr)] lg:items-start lg:gap-10">
            
            {/* Title */}
            {/* RESPONSIVE: Scale font size and center title block on desktop */}
            <h2 className="w-full max-w-[420px] text-3xl md:text-5xl lg:text-6xl font-medium break-words lg:justify-self-center">
              {section.title}
            </h2>

            {/* Items List */}
            <div className="space-y-4 w-full">
              {section.items.map((item, itemIdx) => {
                const key = `${sectionIdx}-${itemIdx}`;
                const isLast = itemIdx === section.items.length - 1;

                return (
                  <div
                    key={key}
                    className={`${!isLast ? "border-b border-black" : ""} pb-4`}
                  >
                    <button
                      className="w-full flex justify-between items-start text-left cursor-default"
                    >
                      <span className="text-sm md:text-base text-black font-medium pr-0 md:pr-6 leading-relaxed">
                        {item.q}
                      </span>
                    </button>

                    {/* Hidden answer div to maintain structure if needed later */}
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out hidden`}>
                      <div className="overflow-hidden">
                        <p className="text-base leading-relaxed pr-10">
                          {/* {item.a} */}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default ExchangePage;